/* EZ reviews (Ban-71, 2026-10-18) — §63. Loaded on product pages from snippets/ez-reviews-data.liquid.
   Replaces how Judge.me's product widget LOOKS, not where reviews come from:
   - Numbers (this item's average, count and 5→1 star bars; the store's average and count) are read from Judge.me's
     widget already in the page (#judgeme_product_reviews, rendered by Shopify) — no request.
   - Review lists come from Judge.me's public review addresses (api.judge.me, cdn.judge.me: the ones Judge.me's own
     widgets use), only once the block is about to scroll into view, 12 reviews per request, kept for the visit.
   - Item with reviews: line "★★★★★ 4.97 · 93 reviews" under the title, tabs "This item (93) | All reviews (1,941)".
     Item without reviews: line "★ 4.99 · 1,941 store reviews", only the store's reviews, each saying which product
     it is about. No "new item" wording anywhere.
   - Page numbers in place (like Macorner): 4 reviews per page on phones, 6 on computers. The block keeps the height
     of its first page, so the product recommendations below never move; after a page change the page scrolls back
     to the first review only when it is above the screen.
   - Photos open in a simple viewer. Judge.me's "earned a reward" note follows Judge.me's own setting (off today).
   Rules kept: no <button> (Facebook Pixel counts button clicks); clicks handled once on window (capture); layout is
   read only inside requestAnimationFrame, never during a click. Judge.me's widget stays in the page (hidden by CSS)
   as data source and fallback: if anything here fails, removing the class "ezr-on" shows it again. */
(function () {
  "use strict";
  var root = document.documentElement;
  var W = document.getElementById("judgeme_product_reviews");
  var cfgEl = document.getElementById("ezReviewsData");
  if (!W || !cfgEl) { root.classList.remove("ezr-on"); return; }
  var C = {};
  try { C = JSON.parse(cfgEl.textContent) || {}; } catch (e) {}
  var SHOP = C.shop || (window.Shopify && window.Shopify.shop) || "";
  var PID = String(C.pid || W.getAttribute("data-product-id") || "");
  if (!SHOP || !PID) { root.classList.remove("ezr-on"); return; }

  /* ---------- numbers already in the page ---------- */
  function num(v) { var n = parseFloat(String(v || "").replace(/,/g, "")); return isFinite(n) ? n : 0; }
  var shopAvg = num(W.getAttribute("data-shop-average-rating"));
  var shopCount = Math.round(num(W.getAttribute("data-shop-review-count")));
  var sumEl = W.querySelector("[data-number-of-reviews]");
  var avgEl = W.querySelector("[data-average-rating]");
  var itemCount = Math.round(num(sumEl && sumEl.getAttribute("data-number-of-reviews")) || num(C.count));
  var itemAvg = num(avgEl && avgEl.getAttribute("data-average-rating")) || num(C.avg);
  var hist = [];
  W.querySelectorAll(".jdgm-histogram__row[data-rating]").forEach(function (r) {
    var s = parseInt(r.getAttribute("data-rating"), 10), f = parseInt(r.getAttribute("data-frequency"), 10);
    if (s >= 1 && s <= 5 && f >= 0) hist[5 - s] = f;
  });
  var hasItem = itemCount > 0;
  if (!hasItem && !(shopCount > 0)) { root.classList.remove("ezr-on"); return; }

  var phone = window.matchMedia ? window.matchMedia("(max-width: 749px)").matches : window.innerWidth < 750;
  var PER = phone ? 4 : 6, BLOCK = 12, REACH = 83 * BLOCK;
  // Judge.me's own setting decides whether "earned a reward" is shown (Judge.me › Settings › transparency badges)
  var JMS = window.jdgmSettings || {};
  var REWARD = JMS.transparency_badges_earned_reward ? (JMS.transparency_badges_earned_reward_text || "Review earned a reward for future purchase") : "";
  var tab = hasItem ? "item" : "all";
  // sort (Judge.me sort_by / sort_dir) and star filter (filter_rating) like Macorner's "All Reviews | 5 Star (n) …";
  // no "lowest rating" sort. Default "Top reviews" = 5-star reviews first, then 4, 3, 2, 1; inside each rating the
  // ones with photos first (Judge.me pictures_first + filter_rating, joined one rating after another), so a 1-star
  // review is only seen when the shopper picks it (1 Star chip or Most recent) — anh 18/10 12:10 + 12:19.
  // The photo strip comes from "with photos", 4–5 star reviews only.
  var SORTS = { top: ["Top reviews", "sort_by=pictures_first"], recent: ["Most recent", "sort_by=created_at&sort_dir=desc"], photos: ["With photos", "sort_by=with_pictures"] };
  var sort = "top", star = 0;
  // stars[tab] = counts for 5…1 stars (item: from Judge.me's histogram in the page; all: asked from Judge.me once)
  var starN = { item: hist.length ? hist.slice() : null, all: null };
  var total = hasItem ? itemCount : shopCount;
  var page = { item: 1, all: 1 };

  function fmt(n) { return Number(n).toLocaleString("en-US"); }
  function stars(n) { var r = Math.round(n), s = ""; for (var i = 0; i < 5; i++) s += i < r ? "★" : "☆"; return s; }
  function el(tag, cls, txt) { var n = document.createElement(tag); if (cls) n.className = cls; if (txt != null) n.textContent = txt; return n; }
  function act(n, name, label) { n.setAttribute("data-ezr", name); n.setAttribute("role", "button"); n.tabIndex = 0; if (label) n.setAttribute("aria-label", label); return n; }

  /* ---------- line under the title ---------- */
  (function line() {
    var a = el("a", "ezr-line");
    a.href = "#ezr";
    a.setAttribute("data-ezr", "goto");
    if (hasItem) {
      a.appendChild(el("span", "ezr-line__stars", stars(itemAvg))).setAttribute("aria-hidden", "true");
      a.appendChild(el("span", "ezr-line__avg", itemAvg.toFixed(2)));
      a.appendChild(el("span", "ezr-line__n", fmt(itemCount) + (itemCount === 1 ? " review" : " reviews")));
    } else {
      a.appendChild(el("span", "ezr-line__stars", "★")).setAttribute("aria-hidden", "true");
      a.appendChild(el("span", "ezr-line__avg", shopAvg.toFixed(2)));
      a.appendChild(el("span", "", "·"));
      a.appendChild(el("span", "ezr-line__n", fmt(shopCount) + " store reviews"));
    }
    var badge = document.querySelector(".product__info-container .jdgm-preview-badge") || document.querySelector(".jdgm-preview-badge");
    var host = badge && (badge.closest(".shopify-app-block") || badge.parentNode);
    if (host) host.appendChild(a);
    else {
      var t = document.querySelector(".product__info-container .product__title");
      if (t && t.parentNode) t.parentNode.insertBefore(a, t.nextSibling);
    }
  })();

  /* ---------- the block ---------- */
  var box = el("section", "ezr");
  box.id = "ezr";
  box.setAttribute("aria-labelledby", "ezr-h");
  var hd = el("div", "ezr__hd");
  var h = el("h2", "ezr__h", "Customer Reviews");
  h.id = "ezr-h";
  hd.appendChild(h);
  box.appendChild(hd);
  var grid = el("div", "ezr__grid"), sum = el("div", "ezr__sum"), main = el("div", "ezr__main");
  grid.appendChild(sum); grid.appendChild(main); box.appendChild(grid);

  var tabsEl = null, tabEls = {};
  if (hasItem) {
    tabsEl = el("div", "ezr__tabs");
    tabsEl.setAttribute("role", "tablist");
    [["item", "This item (" + fmt(itemCount) + ")"], ["all", "All reviews (" + fmt(shopCount) + ")"]].forEach(function (t) {
      var x = act(el("span", "ezr__tab", t[1]), "tab");
      x.setAttribute("role", "tab");
      x.setAttribute("data-tab", t[0]);
      tabEls[t[0]] = x;
      tabsEl.appendChild(x);
    });
  }
  // our own small menu (white card, theme font) instead of the browser's list
  var sortWrap = el("div", "ezr__sortwrap");
  var sortEl = act(el("span", "ezr__sort"), "sort");
  sortEl.setAttribute("aria-haspopup", "listbox");
  sortEl.setAttribute("aria-expanded", "false");
  sortEl.appendChild(el("span", "ezr__sort-l", "Sort by"));
  var sortVal = el("span", "ezr__sort-v", SORTS[sort][0]);
  sortEl.appendChild(sortVal);
  var menu = el("div", "ezr__menu");
  menu.setAttribute("role", "listbox");
  menu.setAttribute("aria-label", "Sort reviews");
  menu.hidden = true;
  Object.keys(SORTS).forEach(function (k) {
    var o = act(el("span", "ezr__opt", SORTS[k][0]), "sortopt");
    o.setAttribute("role", "option");
    o.setAttribute("data-sort", k);
    o.tabIndex = -1;
    menu.appendChild(o);
  });
  function paintMenu() {
    Array.prototype.forEach.call(menu.children, function (o) {
      var on = o.getAttribute("data-sort") === sort;
      o.classList.toggle("is-on", on);
      o.setAttribute("aria-selected", on ? "true" : "false");
    });
  }
  function openMenu(v) {
    menu.hidden = !v;
    sortWrap.classList.toggle("is-open", v);
    sortEl.setAttribute("aria-expanded", v ? "true" : "false");
    if (v) { var cur = menu.querySelector(".is-on") || menu.firstChild; if (cur) cur.focus(); }
  }
  function pickSort(k) {
    openMenu(false);
    sortEl.focus();
    if (!SORTS[k] || k === sort) return;
    sort = k; sortVal.textContent = SORTS[sort][0]; paintMenu();
    page.item = 1; page.all = 1;
    show(false);
  }
  paintMenu();
  sortWrap.appendChild(sortEl);
  sortWrap.appendChild(menu);
  hd.appendChild(sortWrap); // "Sort by" sits on the heading line, right side
  if (tabsEl) main.appendChild(tabsEl);
  // star filter chips
  var chips = el("div", "ezr__chips");
  chips.setAttribute("role", "group");
  chips.setAttribute("aria-label", "Filter reviews by rating");
  main.appendChild(chips);
  function baseCount() { return tab === "item" ? itemCount : shopCount; }
  function starCount(n) { var a = starN[tab]; return n ? (a ? a[5 - n] || 0 : null) : baseCount(); }
  function paintChips() {
    chips.textContent = "";
    var a = starN[tab];
    [0, 5, 4, 3, 2, 1].forEach(function (n) {
      if (n && !a) return; // counts not known yet → only "All Reviews"
      var c = starCount(n), on = n === star;
      var x = act(el("span", "ezr__chip" + (on ? " is-on" : "") + (!c && !on ? " is-off" : ""), (n ? n + " Star" : "All Reviews") + " (" + fmt(c || 0) + ")"), c || on ? "star" : "");
      x.setAttribute("data-star", String(n));
      x.setAttribute("aria-pressed", on ? "true" : "false");
      if (!c && !on) { x.removeAttribute("role"); x.tabIndex = -1; x.setAttribute("aria-disabled", "true"); }
      chips.appendChild(x);
    });
  }
  var allAsk = null;
  function askAllCounts() {
    // five small requests, once (page 1 of each filter, same address as a later click → cached)
    if (!allAsk) allAsk = Promise.all([5, 4, 3, 2, 1].map(function (n) { return getBlock("all", 1, "top", n).then(function (d) { return d.total || 0; }); }))
      .then(function (a) { starN.all = a; if (tab === "all") { paintChips(); paintSummary(); } }, function () { allAsk = null; });
    return allAsk;
  }
  var pwrap = el("div", "ezr__pwrap at-start at-end"), photos = el("div", "ezr__photos"), list = el("div", "ezr__list"), pager = el("nav", "ezr__pager");
  pager.setAttribute("aria-label", "Review pages");
  // photo strip: equal square tiles; on computers two round arrows scroll it (hidden at either end)
  pwrap.appendChild(photos);
  [["is-l", "‹", -1, "Previous photos"], ["is-r", "›", 1, "More photos"]].forEach(function (a) {
    var x = act(el("span", "ezr__parw " + a[0], a[1]), "pscroll", a[3]);
    x.setAttribute("data-dir", String(a[2]));
    pwrap.appendChild(x);
  });
  var stripW = 0;
  function edges() {
    stripW = photos.clientWidth;
    pwrap.classList.toggle("at-start", photos.scrollLeft <= 2);
    pwrap.classList.toggle("at-end", photos.scrollLeft >= photos.scrollWidth - stripW - 2);
  }
  photos.addEventListener("scroll", function () { requestAnimationFrame(edges); }, { passive: true });
  window.addEventListener("resize", function () { requestAnimationFrame(edges); });
  main.appendChild(pwrap); main.appendChild(list); main.appendChild(pager);
  W.parentNode.insertBefore(box, W);
  // one column of reviews (phones, narrow screens) → 4 per page; two columns → 6
  if (!phone && list.clientWidth && list.clientWidth < 696) PER = 4;

  function paintSummary() {
    sum.textContent = "";
    var item = tab === "item";
    var avg = item ? itemAvg : shopAvg, cnt = item ? itemCount : shopCount;
    var sc = el("div", "ezr__score");
    sc.appendChild(el("span", "ezr__avg", avg.toFixed(2)));
    var col = el("div", "");
    col.appendChild(el("div", "ezr__stars", stars(avg))).setAttribute("aria-label", avg.toFixed(2) + " out of 5 stars");
    var hs5 = starN[tab], five = hs5 && hs5[0] != null && cnt ? Math.round(hs5[0] / cnt * 100) : 0;
    col.appendChild(el("div", "ezr__based", fmt(cnt) + (cnt === 1 ? " review" : " reviews")));
    sc.appendChild(col);
    if (five) sc.appendChild(el("span", "ezr__pct", five + "% 5-star")); // shown on phones only (CSS), so a turned tablet stays tidy
    sum.appendChild(sc);
    if (hs5) {
      var hs = el("div", "ezr__hist");
      for (var i = 0; i < 5; i++) {
        var f = hs5[i] || 0, r = el("div", "ezr__hrow");
        r.appendChild(el("span", "", (5 - i) + " star"));
        var bar = el("span", "ezr__bar"), fill = el("i");
        fill.style.width = (cnt ? Math.max(f ? 2 : 0, Math.round(f / cnt * 100)) : 0) + "%";
        bar.appendChild(fill); r.appendChild(bar);
        r.appendChild(el("span", "", fmt(f)));
        hs.appendChild(r);
      }
      sum.appendChild(hs);
    }
    if (tabsEl) for (var k in tabEls) { var on = k === tab; tabEls[k].classList.toggle("is-on", on); tabEls[k].setAttribute("aria-selected", on ? "true" : "false"); }
  }

  /* ---------- Judge.me data ---------- */
  var mem = {}, frame = null;
  function nativeFetch() {
    // Other scripts on the page wrap window.fetch / XMLHttpRequest and break requests to other sites;
    // a blank same-origin frame gives the browser's own fetch.
    try {
      if (!frame) { frame = document.createElement("iframe"); frame.hidden = true; frame.setAttribute("aria-hidden", "true"); frame.tabIndex = -1; document.body.appendChild(frame); }
      if (frame.contentWindow && frame.contentWindow.fetch) return frame.contentWindow.fetch.bind(frame.contentWindow);
    } catch (e) {}
    return window.fetch.bind(window);
  }
  function urlFor(t, block, s, st) {
    var q = "shop_domain=" + encodeURIComponent(SHOP) + "&platform=shopify&per_page=" + BLOCK + "&page=" + block + "&" + SORTS[s || sort][1] + (st ? "&filter_rating=" + st : "");
    return t === "item"
      ? "/reviews/reviews_for_widget?product_id=" + encodeURIComponent(PID) + "&widget_theme=standard&" + q
      : "/reviews/all_reviews_js_based?url=" + encodeURIComponent(SHOP) + "&" + q;
  }
  function getBlock(t, block, s, st) {
    var u = urlFor(t, block, s, st);
    if (mem[u]) return Promise.resolve(mem[u]);
    try { var s = sessionStorage.getItem("ezr:" + u); if (s) { mem[u] = JSON.parse(s); return Promise.resolve(mem[u]); } } catch (e) {}
    // api.judge.me answers every page; cdn.judge.me is quicker for pages it already holds but refuses the rest
    // (tested 18/10: cdn page 2+ failed, api 200 in 0.5–1 s). Third try: api again after a pause.
    var hosts = ["https://api.judge.me", "https://cdn.judge.me", "https://api.judge.me"], waits = [0, 0, 2500];
    function attempt(i) {
      return new Promise(function (ok) { setTimeout(ok, waits[i]); }).then(function () {
        var f = nativeFetch(), ctl = window.AbortController ? new AbortController() : null;
        var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 9000);
        return f(hosts[i] + u, ctl ? { signal: ctl.signal } : undefined).then(function (r) {
          clearTimeout(timer);
          if (!r.ok) throw new Error("status " + r.status);
          return r.json();
        });
      }).then(function (d) {
        var revs = parse(d && d.html), out = { revs: revs };
        if (t === "item" && d && d.total_count != null) out.total = parseInt(d.total_count, 10) || 0;
        if (t === "all" && d && (d.number_of_product_reviews != null)) out.total = (parseInt(d.number_of_product_reviews, 10) || 0) + (parseInt(d.number_of_shop_reviews, 10) || 0);
        mem[u] = out;
        try { sessionStorage.setItem("ezr:" + u, JSON.stringify(out)); } catch (e) {}
        return out;
      }, function (err) {
        if (i + 1 < waits.length) return attempt(i + 1);
        throw err;
      });
    }
    return attempt(0);
  }
  function attr(n, k) { return n ? n.getAttribute(k) : null; }
  function txt(n) { return n ? n.textContent.replace(/\s+/g, " ").trim() : ""; }
  function parse(html) {
    var out = [];
    if (!html) return out;
    var d = new DOMParser().parseFromString(String(html), "text/html");
    d.querySelectorAll(".jdgm-rev").forEach(function (r) { out.push(one(r)); });
    return out;
  }
  function one(r) {
    var ts = r.querySelector(".jdgm-rev__timestamp"), when = ts && ts.getAttribute("data-content"), date = "";
    if (when) { var dt = new Date(when.replace(" UTC", "Z").replace(" ", "T")); if (!isNaN(dt)) date = dt.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }); }
    var pics = [];
    r.querySelectorAll(".jdgm-rev__pic-link").forEach(function (a) {
      var img = a.querySelector("img");
      var big = a.getAttribute("data-mfp-src") || a.getAttribute("href") || "";
      var small = img && (img.getAttribute("data-src") || img.getAttribute("src")) || big;
      if (/^https:\/\//.test(big)) pics.push({ s: small, b: big });
    });
    var prod = r.querySelector(".jdgm-rev__prod-link");
    var loc = txt(r.querySelector(".jdgm-rev__location")).replace(/^\(|\)$/g, "");
    return {
      score: parseInt(attr(r.querySelector(".jdgm-rev__rating"), "data-score"), 10) || 5,
      date: date, title: txt(r.querySelector(".jdgm-rev__title")), body: txt(r.querySelector(".jdgm-rev__body")),
      name: txt(r.querySelector(".jdgm-rev__author")) || "Anonymous", loc: loc,
      ver: r.getAttribute("data-verified-buyer") === "true",
      reward: !!r.querySelector('[data-badge-type="review_earned_for_future_purchase"]'),
      prod: prod ? txt(prod) : "", url: prod && /^https:\/\//.test(prod.getAttribute("href") || "") ? prod.getAttribute("href") : "",
      pics: pics.slice(0, 3)
    };
  }

  /* ---------- painting ---------- */
  function card(v) {
    var c = el("article", "ezr__card");
    var top = el("div", "ezr__top");
    top.appendChild(el("span", "ezr__cstars", stars(v.score))).setAttribute("aria-label", v.score + " out of 5 stars");
    if (v.date) top.appendChild(el("span", "ezr__date", v.date));
    c.appendChild(top);
    var body = v.body, title = v.title;
    // Judge.me fills an empty title with the first words of the review: show those words once
    if (title && body.toLowerCase().indexOf(title.toLowerCase().replace(/[….\s]+$/, "")) === 0) title = "";
    if (title) c.appendChild(el("div", "ezr__t", title));
    if (body) c.appendChild(el("div", "ezr__b", body));
    if (v.pics.length) {
      var ps = el("div", "ezr__pics");
      v.pics.forEach(function (p) {
        var b = act(el("span", "ezr__pic"), "photo", "Open customer photo");
        b.setAttribute("data-big", p.b);
        var im = el("img"); im.src = p.s; im.alt = ""; im.loading = "lazy"; im.decoding = "async";
        b.appendChild(im); ps.appendChild(b);
      });
      c.appendChild(ps);
    }
    if (tab === "all" && v.prod) {
      var pr = v.url ? el("a", "ezr__prod", "Reviewed: " + v.prod) : el("div", "ezr__prod", "Reviewed: " + v.prod);
      if (v.url) pr.href = v.url;
      c.appendChild(pr);
    }
    var who = el("div", "ezr__who");
    who.appendChild(el("span", "ezr__name", v.name));
    if (v.ver) who.appendChild(el("span", "ezr__ver", "✓ Verified"));
    if (v.loc) who.appendChild(el("span", "", "· " + v.loc));
    if (v.reward && REWARD) who.appendChild(el("span", "ezr__inc", "· " + REWARD));
    c.appendChild(who);
    return c;
  }
  function ghosts() { list.textContent = ""; for (var i = 0; i < PER; i++) list.appendChild(el("div", "ezr__ghost")); }
  function paintPhotos(revs) {
    photos.textContent = "";
    photos.scrollLeft = 0;
    gallery = [];
    var n = 0;
    revs.forEach(function (v) { v.pics.forEach(function (p) {
      if (n >= 20 || v.score < 4 || gallery.indexOf(p.b) !== -1) return;
      gallery.push(p.b);
      var b = act(el("span", "ezr__ph"), "photo", "Open customer photo");
      b.setAttribute("data-big", p.b);
      var im = el("img"); im.src = p.s; im.alt = ""; im.loading = "lazy"; im.decoding = "async";
      b.appendChild(im); photos.appendChild(b); n++;
    }); });
    pwrap.hidden = n === 0;
    requestAnimationFrame(edges);
  }
  var stripTab = "";
  function strip(t) {
    if (stripTab === t) return;
    stripTab = t;
    getBlock(t, 1, "photos").then(function (d) { if (tab === t) paintPhotos(d.revs); }, function () { if (tab === t) stripTab = ""; });
  }
  function paintPager() {
    pager.textContent = "";
    // Judge.me serves only the first ~1,000 reviews of a list (tested 18/10: page 83+ of 12 repeats the same page),
    // so page numbers stop there; the count still shows the true total
    var pages = Math.max(1, Math.ceil(Math.min(total, REACH) / PER)), p = page[tab];
    if (pages <= 1) return;
    var row = el("div", "ezr__pgs");
    function pg(label, n, cls, aria) {
      var x = act(el("span", "ezr__pg" + (cls ? " " + cls : ""), label), n ? "page" : "", aria);
      if (n) x.setAttribute("data-page", String(n)); else { x.removeAttribute("role"); x.tabIndex = -1; x.setAttribute("aria-disabled", "true"); }
      return x;
    }
    row.appendChild(pg("‹", p > 1 ? p - 1 : 0, "is-arw" + (p > 1 ? "" : " is-off"), "Previous page"));
    var keep = [1, p - 1, p, p + 1, pages].filter(function (n, i, a) { return n >= 1 && n <= pages && a.indexOf(n) === i; }).sort(function (a, b) { return a - b; });
    var last = 0;
    keep.forEach(function (n) {
      if (n - last > 1) row.appendChild(el("span", "ezr__gap", "…"));
      var x = pg(String(n), n === p ? 0 : n, n === p ? "is-on" : "", "Page " + n);
      if (n === p) { x.setAttribute("aria-current", "page"); x.removeAttribute("aria-disabled"); }
      row.appendChild(x);
      last = n;
    });
    row.appendChild(pg("›", p < pages ? p + 1 : 0, "is-arw" + (p < pages ? "" : " is-off"), "Next page"));
    pager.appendChild(row);
    pager.appendChild(el("div", "ezr__count", "Reviews " + fmt((p - 1) * PER + 1) + "–" + fmt(Math.min(p * PER, total)) + " of " + fmt(total)));
  }
  var lastH = 0, ticket = 0;
  function show(scrollBack) {
    var t = tab, p = page[t], first = (p - 1) * PER, my = ++ticket;
    // hold the current height only while the next page loads (height measured earlier, not during the click)
    if (lastH && list.firstChild) list.style.minHeight = lastH + "px";
    if (!list.firstChild) ghosts();
    list.classList.add("is-busy");
    pageRevs(t, first).then(function (d) {
      if (my !== ticket) return;
      if (d.total != null) total = d.total;
      var revs = d.revs;
      if (!revs.length && p > 1) { page[t] = 1; return show(false); }
      list.textContent = "";
      if (!revs.length) { total = 0; list.appendChild(el("div", "ezr__err", "No reviews match this filter.")); }
      revs.forEach(function (v) { list.appendChild(card(v)); });
      list.style.minHeight = "";
      list.classList.remove("is-busy");
      strip(t);
      paintPager();
      settle(t, scrollBack);
    }, function () {
      if (my !== ticket) return;
      if (fallback(t)) return;
      list.classList.remove("is-busy");
      list.style.minHeight = "";
      list.textContent = "";
      var e = el("div", "ezr__err", "Reviews couldn’t load right now.");
      e.appendChild(act(el("span", "", "Try again"), "retry"));
      list.appendChild(e); // page numbers stay, so another page can still be chosen
    });
  }
  // the reviews of one page: one Judge.me list, or for "Top reviews" with no star chosen, the 5…1-star lists one
  // after another (counts known from the chart; until the store counts arrive, the plain list is used)
  function take(t, s, o, n) {
    var b1 = Math.floor(o / BLOCK) + 1, b2 = Math.floor((o + n - 1) / BLOCK) + 1, jobs = [];
    for (var b = b1; b <= b2; b++) jobs.push(getBlock(t, b, sort, s));
    return Promise.all(jobs).then(function (ds) {
      var all = [];
      ds.forEach(function (d) { all = all.concat(d.revs); });
      var start = o - (b1 - 1) * BLOCK;
      return { revs: all.slice(start, start + n), total: b1 === 1 ? ds[0].total : null };
    });
  }
  function pageRevs(t, first) {
    var counts = starN[t];
    // store list, Top reviews: wait for the store counts so the order is right from the first page
    if (t === "all" && !counts && sort === "top" && !star) return askAllCounts().then(function () { return starN.all ? pageRevs(t, first) : take(t, 0, first, PER); });
    if (sort !== "top" || star || !counts) return take(t, star, first, PER);
    var out = [], jobs = [], base = 0, need = PER, at = first;
    for (var i = 0; i < 5 && need > 0; i++) {
      var c = counts[i] || 0;
      if (at < base + c) {
        var o = at - base, n = Math.min(need, c - o);
        jobs.push(take(t, 5 - i, o, n));
        at += n; need -= n;
      }
      base += c;
    }
    return Promise.all(jobs).then(function (rs) {
      rs.forEach(function (r) { out = out.concat(r.revs); });
      return { revs: out, total: baseCount() };
    });
  }
  function fallback(t) {
    // Judge.me's own widget may already hold this item's first reviews: show those rather than an error
    // (first page only; on later pages the error with "Try again" keeps the page numbers).
    if (t !== "item" || page[t] !== 1 || star) return false;
    var own = W.querySelectorAll(".jdgm-rev");
    if (!own.length) return false;
    list.classList.remove("is-busy");
    list.style.minHeight = "";
    list.textContent = "";
    var revs = [];
    own.forEach(function (r) { revs.push(one(r)); });
    revs.slice(0, PER).forEach(function (v) { list.appendChild(card(v)); });
    paintPhotos(revs);
    pager.textContent = "";
    return true;
  }
  function settle(t, scrollBack) {
    requestAnimationFrame(function () {
      // each card keeps its own height (no stretching); remember the height for the next page change
      lastH = list.offsetHeight;
      if (scrollBack) {
        var top = list.getBoundingClientRect().top;
        if (top < 0) window.scrollTo({ top: Math.max(0, window.pageYOffset + top - 90), behavior: "smooth" });
      }
    });
  }

  /* ---------- photo viewer ---------- */
  var lb = null, lastFocus = null, gallery = [], lbIdx = -1, lbImg = null, lbCount = null;
  function openPhoto(src) {
    close();
    lastFocus = document.activeElement;
    lb = el("div", "ezr-lb");
    lb.setAttribute("role", "dialog");
    lb.setAttribute("aria-modal", "true");
    lb.setAttribute("aria-label", "Customer photo");
    lb.setAttribute("data-ezr", "close");
    var im = el("img"); im.src = src; im.alt = "Customer photo";
    lb.appendChild(im);
    lbImg = im;
    lbIdx = gallery.indexOf(src);
    if (lbIdx !== -1 && gallery.length > 1) {
      [["is-l", "‹", -1, "Previous photo"], ["is-r", "›", 1, "Next photo"]].forEach(function (a) {
        var n = act(el("span", "ezr-lb__nav " + a[0], a[1]), "lbnav", a[3]);
        n.setAttribute("data-dir", String(a[2]));
        lb.appendChild(n);
      });
      lbCount = el("span", "ezr-lb__n", (lbIdx + 1) + " / " + gallery.length);
      lb.appendChild(lbCount);
    }
    var x = act(el("span", "ezr-lb__x", "×"), "close", "Close");
    lb.appendChild(x);
    document.body.appendChild(lb);
    x.focus();
  }
  function step(d) {
    if (!lb || lbIdx === -1 || gallery.length < 2) return;
    lbIdx = (lbIdx + d + gallery.length) % gallery.length;
    lbImg.src = gallery[lbIdx];
    lbCount.textContent = (lbIdx + 1) + " / " + gallery.length;
  }
  function close() { if (lb) { lb.remove(); lb = null; if (lastFocus && lastFocus.focus) lastFocus.focus(); } }

  /* ---------- one listener for every click / key ---------- */
  function handle(t, e) {
    var name = t.getAttribute("data-ezr");
    if (name === "star") { var sn = parseInt(t.getAttribute("data-star"), 10) || 0; if (sn !== star) { star = sn; page[tab] = 1; total = starCount(sn) || 0; paintChips(); show(false); } return; }
    if (name === "sort") { openMenu(menu.hidden); return; }
    if (name === "sortopt") { pickSort(t.getAttribute("data-sort")); return; }
    if (name === "goto") { e.preventDefault(); box.scrollIntoView({ behavior: "smooth", block: "start" }); start(); return; }
    if (name === "tab") { var k = t.getAttribute("data-tab"); if (k && k !== tab) { tab = k; star = 0; total = baseCount(); list.style.minHeight = ""; lastH = 0; paintSummary(); paintChips(); list.textContent = ""; photos.textContent = ""; show(false); } return; }
    if (name === "page") { var n = parseInt(t.getAttribute("data-page"), 10); if (n) { page[tab] = n; show(true); } return; }
    if (name === "pscroll") { photos.scrollBy({ left: (parseInt(t.getAttribute("data-dir"), 10) || 1) * Math.max(200, stripW - 40), behavior: "smooth" }); return; }
    if (name === "lbnav") { step(parseInt(t.getAttribute("data-dir"), 10) || 1); return; }
    if (name === "photo") { openPhoto(t.getAttribute("data-big")); return; }
    if (name === "retry") { show(false); return; }
    if (name === "close") { if (e.target === t || t.classList.contains("ezr-lb__x")) close(); return; }
  }
  window.addEventListener("click", function (e) {
    var t = e.target && e.target.closest && e.target.closest("[data-ezr]");
    if (!menu.hidden && !sortWrap.contains(e.target)) openMenu(false);
    if (t && (box.contains(t) || t.classList.contains("ezr-line") || (lb && lb.contains(t)))) handle(t, e);
  }, true);
  window.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && lb) { close(); return; }
    if (lb && (e.key === "ArrowLeft" || e.key === "ArrowRight")) { e.preventDefault(); step(e.key === "ArrowLeft" ? -1 : 1); return; }
    if (!menu.hidden) {
      if (e.key === "Escape") { e.preventDefault(); openMenu(false); sortEl.focus(); return; }
      if (e.key === "ArrowDown" || e.key === "ArrowUp") {
        e.preventDefault();
        var opts = Array.prototype.slice.call(menu.children), i = opts.indexOf(document.activeElement);
        i = i === -1 ? 0 : (i + (e.key === "ArrowDown" ? 1 : -1) + opts.length) % opts.length;
        opts[i].focus();
        return;
      }
      if (e.key === "Tab") openMenu(false);
    }
    if (e.key !== "Enter" && e.key !== " ") return;
    var t = e.target && e.target.closest && e.target.closest("[data-ezr]");
    if (!t) return;
    var role = t.getAttribute("role");
    if ((role === "button" || role === "tab" || role === "option") && (box.contains(t) || (lb && lb.contains(t)))) { e.preventDefault(); handle(t, e); }
  }, true);

  /* ---------- start when the block is near ---------- */
  paintSummary();
  paintChips();
  ghosts();
  var started = false;
  // store counts are asked as soon as the block is near, so "All reviews" opens with its chart already filled
  function start() { if (started) return; started = true; show(false); askAllCounts(); }
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (es) { if (es.some(function (x) { return x.isIntersecting; })) { io.disconnect(); start(); } }, { rootMargin: "900px 0px" });
    io.observe(box);
  } else start();
})();
